import { memo, useState } from "react";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import Highlight from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Highlight/Highlight";
import CompletedTaskCard from "@coworker/apprestructured/src/task-management/components/TaskCard/variants/CompletedTaskCard/CompletedTaskCard";
import Actions from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Actions/Actions";
import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";
import FixaCheckbox from "@coworker/apprestructured/src/shared/wrappers/FixaCheckbox/FixaCheckbox";
import ListableTaskCardWrapper from "@coworker/apprestructured/src/task-management/components/TaskCard/wrappers/NormalTaskWrapper/ListableTaskCardWrapper";
import { LOADING } from "@coworker/apprestructured/src/task-management/loading";

function CompletedTaskCardDemo() {
  const [taskType, setTaskType] = useState("Custom task");
  const [assigned, setAssigned] = useState("John Lovén");
  const [date, setDate] = useState("Completed 2025-10-16");
  const [priority, setPriority] = useState(true);
  const [safetyAlarm, setSafetyAlarm] = useState(false);
  const [loadingTaskType, setLoadingTaskType] = useState(false);
  const [loadingAssigned, setLoadingAssigned] = useState(false);
  const [loadingDate, setLoadingDate] = useState(false);

  return (
    <Demo>
      <Name>CompletedTaskCard (listable)</Name>
      <Highlight>
        <ListableTaskCardWrapper>
          <CompletedTaskCard
            taskType={loadingTaskType ? LOADING : taskType}
            assigned={loadingAssigned ? LOADING : assigned}
            date={loadingDate ? LOADING : date}
            priority={priority}
            safetyAlarm={safetyAlarm}
          >
            fragments
          </CompletedTaskCard>
        </ListableTaskCardWrapper>
      </Highlight>
      <Actions>
        <FixaInputField
          label="taskType"
          type="text"
          id="completedtaskcarddemo-taskType"
          value={taskType}
          onChange={(e) => setTaskType(e.target.value)}
        />
        <FixaInputField
          label="assigned"
          type="text"
          id="completedtaskcarddemo-assigned"
          value={assigned}
          onChange={(e) => setAssigned(e.target.value)}
        />
        <FixaInputField
          label="date"
          type="text"
          id="completedtaskcarddemo-date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />
        <FixaCheckbox
          id="completedtaskcarddemo-priority"
          label="priority"
          checked={priority}
          value="completedtaskcarddemo-priority"
          onChange={() => setPriority((prev) => !prev)}
        />
        <FixaCheckbox
          id="completedtaskcarddemo-safetyAlarm"
          label="safetyAlarm"
          checked={safetyAlarm}
          value="completedtaskcarddemo-safetyAlarm"
          onChange={() => setSafetyAlarm((prev) => !prev)}
        />
        <FixaCheckbox
          id="completedtaskcarddemo-loadingTaskType"
          label="loadingTaskType"
          checked={loadingTaskType}
          value="completedtaskcarddemo-loadingTaskType"
          onChange={() => setLoadingTaskType((prev) => !prev)}
        />
        <FixaCheckbox
          id="completedtaskcarddemo-loadingAssigned"
          label="loadingAssigned"
          checked={loadingAssigned}
          value="completedtaskcarddemo-loadingAssigned"
          onChange={() => setLoadingAssigned((prev) => !prev)}
        />
        <FixaCheckbox
          id="completedtaskcarddemo-loadingDate"
          label="loadingDate"
          checked={loadingDate}
          value="completedtaskcarddemo-loadingDate"
          onChange={() => setLoadingDate((prev) => !prev)}
        />
      </Actions>
    </Demo>
  );
}

export default memo(CompletedTaskCardDemo);
